<template>
  <b-card
    title="Transit"
    class="shadow-sm"
  >
    <b-row>
      <b-col>
        <b-form-group
          class="transits-form-group"
          label-for="transits-component-select"
        >

          <b-form-tags
            id="transits-component-select"
            v-model="selectedTags"
            size="lg"
            add-on-change
            no-outer-focus
          >
            <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
              <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
                <li v-for="tag in tags" :key="tag" class="list-inline-item">
                  <b-form-tag
                    @remove="removeTag(tag)"
                    :title="tag"
                    :disabled="disabled"
                    variant="secondary"
                  >{{ tag }}</b-form-tag>
                </li>
              </ul>
              <div v-else class="selected-transits-empty d-flex align-items-center">
                <span>Aucun transit sélectionné</span>
              </div>
              <b-form-select
                v-bind="inputAttrs"
                v-on="inputHandlers"
                :disabled="disabled || availableTransitsOptions.length === 0"
                :options="availableTransitsOptions"
              >
                <template #first>
                  <!-- This is required to prevent bugs with Safari -->
                  <option disabled value="">Sélectionner transits</option>
                </template>
              </b-form-select>
            </template>
          </b-form-tags>
        </b-form-group>

      </b-col>

      <b-col class="mt-4 mt-md-0">
        <b-form-group
          label-for="transitInformation-input"
          class="mb-0"
          :state="formTransit.transitInformation.state"
          :invalid-feedback="formTransit.transitInformation.invalidFeedback"
        >
          <b-form-textarea
            id="transitInformation-input"
            class="mt-1"
            :value="formTransit.transitInformation.value"
            @input="$emit('didChangeTransitInformation', $event)"
            placeholder="Informations supplémentaires sur le transit..."
          ></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>
  </b-card>

</template>

<script>
import api from "../../../services/api";

export default {

  name: "DailyStatusCardTransit",

  props: {

    formTransit: {
      type: Object,
      required: true
    },

    dailyTransits: {
      type: Array,
      required: false
    }
  },

  data(){
    return {
      transits: [],
      selectedTags: []
    }
  },

  watch: {
    'selectedTags': function (newValue, oldValue) {
      let selectedTransitsIds = []
      this.selectedTags.map(selectedTag => {
        let transit = this.transits.find(transit => transit.name === selectedTag)
        if (transit) {
          selectedTransitsIds.push(transit.id)
        }
      })
      let isEmptying = oldValue.length > 0 && newValue.length === 0
      if(selectedTransitsIds.length > 0 || isEmptying){
        this.$emit('didChangeSelectedTransits', selectedTransitsIds)
      }
    }
  },

  computed: {
    availableTransitsOptions() {
      return this.transits
        .filter(transit =>
          this.selectedTags.indexOf(transit.name) === -1
        ).map(transit => (
          transit.name
        ))
    }
  },

  created () {
    this.fetchTransits()
    this.setAlreadySelectedTransits()
  },

  methods: {

    fetchTransits() {
      api
        .get(`/transit`)
        .then(response => {
          this.transits = response.data
        })
    },

    setAlreadySelectedTransits() {
      if (this.dailyTransits) {
        this.dailyTransits.map(selectedTransit =>
          this.selectedTags.push(selectedTransit.transit.name)
        )
      }
    }
  }

}
</script>

<style scoped>
.form-group textarea {
  min-height: 70px;
}
.selected-transits-empty {
  color: var(--secondary-text-color);
  font-size: 12px;
}
@media (min-width: 944px) {
  .transits-form-group {
    min-width: 634px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dailyStatus/cards/DailyStatusCardTransit.vue